import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/form-register.tsx");
